import { createContext, useContext } from 'react';
import { CustomerSwiper, TextModule } from '..';
import css from './index.module.scss';

const swiperTypes = createContext({
    FULL_IMAGE: 'full_image' || 1,
    FULL_IMAGE_WITH_TEXT_TOP: 'full_image_with_text_top' || 2,
    FULL_IMAGE_WITH_TEXT_BOTTOM: 'full_image_with_text_bottom' || 3,
    CONTAINER_IMAGE_WITH_TEXT_TOP: 'container_image_with_text_top' || 4,
    CONTAINER_IMAGE_WITH_TEXT_BOTTOM: 'container_image_with_text_bottom' || 5,
});
const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { text: 'Power pretty much anything ' },
    desc: {
        text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    },
    items: [
        { img: '/img/banner_house_big.jpg', desc: '' },
        { img: '/img/banner_cell_big.jpg', desc: '' },
        { img: '/img/banner_house_big.jpg', desc: '' },
        { img: '/img/banner_cell_big.jpg', desc: '' },
    ],
};
const defaultStyle = {
    type: 'full_image',
    backColor: '#fff',
    guideStyle: {},
    titleStyle: {},
    descStyle: {},
    config: {
        theme: 'white',
        fullScreen: true,
        textStyle: {},
    },
};
export default function SwiperBanner({ data, cssStyle }: any) {
    const dataObj = {
        guide: { ...defaultData.guide, ...(data?.guide || {}) },
        title: { ...defaultData.title, ...(data?.title || {}) },
        desc: { ...defaultData.desc, ...(data?.desc || {}) },
        items: data?.items || defaultData.items,
    };
    const { guide, title, desc, items } = dataObj;
    const styles = {
        type: cssStyle?.type ?? defaultStyle.type,
        backColor: cssStyle?.backColor ?? defaultStyle.backColor,
        guideStyle: cssStyle?.guideStyle ?? {},
        titleStyle: cssStyle?.titleStyle ?? {},
        descStyle: cssStyle?.descStyle ?? {},
        config: {
            theme: cssStyle?.config?.theme ?? defaultStyle.config.theme,
            fullScreen: cssStyle?.config?.fullScreen ?? defaultStyle.config.fullScreen,
            textStyle: { ...defaultStyle.config.textStyle, ...cssStyle?.config?.textStyle },
            webpUrl: cssStyle?.webpUrl,
        },
    };
    const { type, backColor, guideStyle, titleStyle, descStyle, config } = styles;
    const types = useContext(swiperTypes);
    const isWhiteTheme = backColor === '#fff' || backColor === '#ffffff' || backColor === 'transparent' || backColor === 'white';

    return (
        <div className={`${css.swiperBanner} swiperBanner`} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
            {type === types.FULL_IMAGE && (
                <CustomerSwiper
                    data={items}
                    cssStyle={{
                        ...config,
                        ...{ theme: isWhiteTheme ? '#fff' : '#000' },
                    }}
                />
            )}
            {type === types.FULL_IMAGE_WITH_TEXT_TOP && (
                <div className="textTopWrapper">
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-SemiBold)',
                                    color: isWhiteTheme ? '#03060b' : '#fff',
                                    fontSize: '.16rem',
                                    lineHeight: '.2rem',
                                    textAlign: 'center',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-Bold)',
                                    margin: '.06rem 0 0',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#fff',
                                    fontSize: '.24rem',
                                    lineHeight: '.34rem',
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-Medium)',
                                    margin: '.08rem 0 .3rem',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#919191',
                                    fontSize: '.14rem',
                                    lineHeight: '.22rem',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ theme: isWhiteTheme ? '#fff' : '#000' },
                        }}
                    />
                </div>
            )}
            {type === types.FULL_IMAGE_WITH_TEXT_BOTTOM && (
                <div className="textBottomWrapper">
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ theme: isWhiteTheme ? '#fff' : '#000' },
                        }}
                    />
                    <div className="container">
                        <TextModule
                            data={guide}
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-SemiBold)',
                                    color: isWhiteTheme ? '#03060b' : '#fff',
                                    margin: '.3rem 0 0',
                                    fontSize: '.16rem',
                                    lineHeight: '.2rem',
                                    textAlign: 'center',
                                },
                                ...guideStyle,
                            }}
                        />
                        <TextModule
                            data={title}
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-Bold)',
                                    margin: '.06rem 0 0',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#fff',
                                    fontSize: '.24rem',
                                    lineHeight: '.34rem',
                                },
                                ...titleStyle,
                            }}
                        />
                        <TextModule
                            cssStyle={{
                                ...{
                                    fontFamily: 'var(--font-family-Medium)',
                                    margin: '.08rem 0 0',
                                    textAlign: 'center',
                                    color: isWhiteTheme ? '#03060b' : '#919191',
                                    fontSize: '.14rem',
                                    lineHeight: '.22rem',
                                },
                                ...descStyle,
                            }}
                            data={desc}
                        />
                    </div>
                </div>
            )}
            {type === types.CONTAINER_IMAGE_WITH_TEXT_BOTTOM && (
                <div className="container">
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false, theme: isWhiteTheme ? '#fff' : '#000' },
                        }}
                    />
                    <TextModule
                        data={guide}
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-SemiBold)',
                                color: isWhiteTheme ? '#03060b' : '#fff',
                                margin: '.3rem 0 0',
                                fontSize: '.16rem',
                                lineHeight: '.2rem',
                                textAlign: 'center',
                            },
                            ...guideStyle,
                        }}
                    />
                    <TextModule
                        data={title}
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-Bold)',
                                margin: '.06rem 0 0',
                                textAlign: 'center',
                                color: isWhiteTheme ? '#03060b' : '#fff',
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                            },
                            ...titleStyle,
                        }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-Medium)',
                                margin: '.08rem 0 0',
                                textAlign: 'center',
                                color: isWhiteTheme ? '#03060b' : '#919191',
                                fontSize: '.14rem',
                                lineHeight: '.22rem',
                            },
                            ...descStyle,
                        }}
                        data={desc}
                    />
                </div>
            )}
            {type === types.CONTAINER_IMAGE_WITH_TEXT_TOP && (
                <div className="container">
                    <TextModule
                        data={guide}
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-SemiBold)',
                                color: isWhiteTheme ? '#03060b' : '#fff',
                                fontSize: '.16rem',
                                lineHeight: '.2rem',
                                textAlign: 'center',
                            },
                            ...guideStyle,
                        }}
                    />
                    <TextModule
                        data={title}
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-Bold)',
                                margin: '.06rem 0 0',
                                textAlign: 'center',
                                color: isWhiteTheme ? '#03060b' : '#fff',
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                            },
                            ...titleStyle,
                        }}
                    />
                    <TextModule
                        cssStyle={{
                            ...{
                                fontFamily: 'var(--font-family-Medium)',
                                margin: '.08rem 0 .3rem',
                                textAlign: 'center',
                                color: isWhiteTheme ? '#03060b' : '#919191',
                                fontSize: '.14rem',
                                lineHeight: '.22rem',
                            },
                            ...descStyle,
                        }}
                        data={desc}
                    />
                    <CustomerSwiper
                        data={items}
                        cssStyle={{
                            ...config,
                            ...{ fullScreen: false, theme: isWhiteTheme ? '#fff' : '#000' },
                        }}
                    />
                </div>
            )}
        </div>
    );
}
